module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"label":"Выберите статус, в которые нужно переместить кандидатов из удаляемого статуса.","confirm":"Подтвердить","delete":"Удаление статуса","warning":"Cтатус удалится во всех вакансиях!"}}')
  delete Component.options._Ctor
}
